import React from 'react';

const BackToCalendarButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center gap-2 text-gray-600 hover:text-indigo-600 transition mb-4 group"
  >
    <svg className="h-5 w-5 group-hover:-translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
    <span className="text-sm md:text-base font-medium">Retour au calendrier</span>
  </button>
);

export default BackToCalendarButton;
